// Widget Scripts
import swiperWidget from './js/widgets/swiperWidget.js';
import cardWidget from './js/widgets/cardWidget.js';
import cardWidgetImage from './js/widgets/cardWidgetImage.js';
import seoWidget from './js/widgets/seoWidget.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import staticSponsorsWidget from './js/widgets/staticSponsorsWidget.js';
import * as socialNetworkWidget from './js/widgets/socialNetworkWidget.js';
import sponsors from './js/widgets/sponsors.js';
// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
   swiperWidget();  
   seoWidget(); 
   cardWidget();
   cardWidgetImage();
   multiScheduleFeature();
  
  });
  $(window).on('load', function() {
    socialNetworkWidget.facebookfeed(true); 
    
});
}
$(document).ready(function() {
  sponsors();
   
  staticSponsorsWidget();
});
